export default {
  // MfaSetting
  userAdd: '사용자 추가',
  selectDelete: '선택 삭제',
  modifyBtn: '수정',
  userName: '사용자명',
  userNumber: '사용자 번호',
  userEmail: '사용자 이메일',
  registrationDate: '최초 등록일시',
  state: '적용상태',
  userDelete: '사용자 삭제',
  alertMsg: '삭제할 항목을 선택해 주세요.',
  deleteMsg: '사용자를 삭제하시겠습니까?',
  userRegisterMsg: '사용자가 등록 되었습니다.',
  userUpdaterMsg: '사용자 정보가 수정 되었습니다.',
  userEnabledMsg: '사용자가 미적용 상태로 변경 되었습니다.',
};
